module.exports = {
  apiHost: "https://api.amara.sensoreal.com.au",
  assetsHost: "https://assets.amara.sensoreal.com.au",
  brandName: "Amara",
  header: {
    text: { en: "Your Amara Selections" },
    logo: "",
    companyLogo: "",
    color: "#fff",
  },
  langs: [{ code: "en", dir: "ltr" }],
  style: {
    primaryColor: "#003a40",
    textColor: "#fff",
    // font: "avenir",
  },
  contact: {
    website:
      "https://avid.com.au/communities/residential/villaworld/qld/amara/",
    address: "22 Skybury Street, Ormeau QLD",
    phone: "1800 317 355",
    email: "",
  },
  links: {
    privacy: "",
    youtube: "https://www.youtube.com/channel/UCEnh4QABTOnsovDd-Hg45OQ",
    linkedin: "https://au.linkedin.com/company/avid-property-group",
    twitter: "",
    instagram: "https://www.instagram.com/avid_together/",
    facebook: "https://www.facebook.com/AVIDPropertyGroupAustralia/",
  },
  footerLogo: "https://assets.amara.sensoreal.com.au/misc/AVID_White_72dpi.png",
};
